// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1XpCJ","bigColWidth":"Table_bigColWidth__YoBdw","biggerColWidth":"Table_biggerColWidth__34mkS","row":"Table_row__39Up9","col":"Table_col__3H4q-"};